import request from '@/utils/request'

// 获取获取班级列表
export const getClassLists = (data) => {
    return request({
        url: '/class/lists',
        params: data
    })
}

// 获取获取年级+班级列表
export const getClassClassLists = () => {
    return request({
        url: '/class/tree'
    })
}

// 获取班级选项列表
export const getClassOptionLists = (data) => {
    return request({
        url: '/class/option/lists',
        params: data
    })
}

// 获取获取学短+年级+班级列表
export const getFullTree = () => {
    return request({
        url: '/class/full/tree'
    })
}

// 获取获取学短+年级+班级列表
export const getDeptTree = (data) => {
    return request({
        url: '/class/department/tree',
        params: data
    })
}
// 批量启用
export const batchEnable = (data) => {
    return request({
        url: '/class/manage',
        method: 'PATCH',
        data: {
            method: 'batch_enable',
            data
        }
    })
}

// 批量禁用
export const batchDisable = (data) => {
    return request({
        url: '/class/manage',
        method: 'PATCH',
        data: {
            method: 'batch_disable',
            data
        }
    })
}

// 班级-详情
export const getClassDetail = (id) => {
    return request({
        url: `/class/${id}`
    })
}

// 班级-修改
export const putClassModel = (data) => {
    return request({
        url: '/class/manage',
        method: 'PUT',
        data
    })
}

// 班级-添加
export const addClassModel = (data) => {
    return request({
        url: '/class/manage',
        method: 'POST',
        data
    })
}

// 班级-删除
export const delClassModel = (id) => {
    return request({
        url: `/class/${id}`,
        method: 'DELETE'
    })
}

// 批量排序
export const batchSort = (data) => {
    return request({
        url: '/class/manage',
        method: 'PATCH',
        data: {
            method: 'batch_update_order',
            data
        }
    })
}
